export default __webpack_public_path__ + "static/media/img9.5313d174.png";